import { Fragment } from 'react';
import { Link, Outlet, useMatch } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Breadcrumb } from '@components/breadcrumb';
import { Button } from '@components/button';
import { IconAddPlus } from '@components/icons/add-plus';
import { useIsMobile } from '@hooks/use-is-mobile';

import { Header } from 'components/headers';
import { Tab, useTabState, TabList } from 'components/Tabs';
import { useStore } from 'models/Provider';

export const Templates = observer(function Templates() {
  const { t } = useStore();
  const section = useMatch('/settings/templates/:section/*')?.params.section || 'emails';

  return (
    <Fragment>
      <Header
        // @ts-ignore why does this untyped component only complain about this prop
        mobileTitle={t('company.templates.crumbs.root')}
        actions={<Actions section={section} />}
        tabs={<TemplateTabs section={section} />}
        breadcrumbs={
          <Breadcrumb
            items={[{ label: t('company.templates.crumbs.root'), link: '/settings/templates' }]}
          />
        }
      />
      <Outlet />
    </Fragment>
  );
});

const Actions = observer<{ section: string }>(function Actions({ section }) {
  const { t } = useStore();
  const isMobile = useIsMobile();

  const link = `${section}/new`;
  const text = t(`company.templates.${section}.new`);

  return (
    <Link to={link} style={{ width: isMobile ? '100%' : 'auto' }}>
      <Button
        {...(isMobile && { style: { width: '100%' } })}
        iconLeft={<IconAddPlus />}
        text={text}
      />
    </Link>
  );
});

const TemplateTabs = observer<{ section: string }>(function TemplateTabs({ section }) {
  const { t } = useStore();

  const tabIndex = section === 'emails' ? 0 : 1;
  const tabState = useTabState({ selectedId: tabIndex });

  return (
    <Fragment>
      {/* @ts-ignore TabList is untyped */}
      <TabList state={tabState} label="Template selection">
        {/* @ts-ignore TabList is untyped */}
        <Tab link="emails">{t('company.templates.tabs.emails')}</Tab>

        {/* @ts-ignore TabList is untyped */}
        <Tab link="tasks">{t('company.templates.tabs.tasks')}</Tab>
      </TabList>
    </Fragment>
  );
});
